export default __webpack_public_path__ + "static/1138-e9bf92893593be3a062b35c71351f9b9.gif";